import React, { Fragment, useState, useEffect } from "react";
import { Col } from 'reactstrap';
import classNames from 'classnames';
import { useHistory, Link } from "react-router-dom";
import { User as UserIcon, Headphones, FileText, LogIn, DollarSign } from "react-feather";
import Tawk from "./Tawk";

import NotificationBell from "./NotificationBell";
import DefaultAvatarImg from "~/assets/images/profile/defaultAvatar.png";

import security from "~/services/security";
import User         from "~/services/user";
import useResize    from "~/hooks/useResize";

const RightBar = ({user})=> {

  const history = useHistory();

  const [menuDropdown , setMenuDropDown] = useState(false);
  const [showTawk     , setShowTawk]     = useState(false);

  const [profile     , setProfile]     = useState({gender: "M", avatar: DefaultAvatarImg});

  const [width] = useResize();

  const logout = async ()=> {
    await security.logout();
    history.push({ pathname: "/login" , message: {text:"You are now logged out!", type:"success"} });
  };

  useEffect(()=> {
    (async ()=> {
      setProfile(await User.profile() || {gender : "M", avatar: DefaultAvatarImg});
    })();
  }, []);

  return (
    <Fragment>
      <Col size={6} className="right-header">

        <div className="nav-right pull-right right-header p-0">
          <ul>
            <li>
              <a href="https://t.me/askearndorado" target="_blank">
                { /* <Headphones id="support" color={showTawk ? "#ffa200" : "black"} > {setShowTawk(!showTawk)}}></Headphones> */ }
                 <Headphones />
              </a>
            </li>

            <li className="onhover-dropdown p-0">
              <div className="media profile-media" onClick={() => setMenuDropDown(!menuDropdown)} style={{marginLeft: 15}}>
                <img className="avatar" src={profile.avatar} style={{borderRadius: '100%' }} />
              </div>

              <ul className={ classNames("profile-dropdown onhover-show-div", {active: menuDropdown})}>
                <Link className="text-dark" to={"/profile"}> <li onClick={()=> setMenuDropDown(false)}> <UserIcon /> Profile </li> </Link>
                { width > 992 && <Link className="text-dark" to={"/wallet"}> <li onClick={()=>setMenuDropDown(false)}>  <DollarSign /> Wallet </li> </Link>}
                <Link className="text-dark" to={"/support"}> <li onClick={()=>setMenuDropDown(false)}>  <Headphones /> Contact </li> </Link>
                <a className="text-dark" target="_blank" href="https://earndorado.com/terms"> <li onClick={()=>setMenuDropDown(false)}>  <FileText /> Terms&Cond </li> </a>
                <li onClick={()=> { logout(); setMenuDropDown(false)}}> <LogIn/>  Log Out </li>
              </ul>

            </li>
          </ul>
        </div>

        <NotificationBell />
      </Col>

      { /* <Tawk showTawk={showTawk} setShowTawk={setShowTawk} user={user}></Tawk> */}
    </Fragment>
  );
}

export default RightBar;
